<template>
 <div class="collection-info-section" :class="{'--open': isOpen}">
   <div class="collection-info-section__head" @click="changeOpen">
     <span class="h5 semibold">{{ headTitle }}</span>
     <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
   </div>
   <div
     v-html="bodyMessage"
     class="collection-info-section__body h5"
     :class="{ 'collection-info-section__body_decoration': getCharFromRedactor(characteristic) }"
   />
 </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import getCharFromRedactor from '~/utils/getCharFromRedactor'

const props = defineProps({
  characteristic: {
    type: Object as any,
    default: () => {}
  }
});

const isOpen = ref(true);

const headTitle = computed(() => {
  return props.characteristic?.nameForProduct || props.characteristic?.name
});
const bodyMessage = computed(() => {
  return props?.characteristic?.values?.[0]?.value || ""
});

const changeOpen = () => {
  isOpen.value = !isOpen.value;
}
</script>

<style lang="scss" scoped>
.collection-characteristic-section {}
</style>
<style>
.collection-info-section__body_decoration {
  a {
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
